import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { BaseColumnComponent } from '~components/dynamic-table/column-components/base-column.component';
import { QuickSearchColumnModel } from '~components/dynamic-table/models/column-types/quick-search-column.model';
import { Identifyable } from '~core/abstractions/identifyable';
import { FormControlPipe } from '~core/pipes/form-control.pipe';
import { QuickSearchConfigPipe } from '~core/pipes/quick-search-config.pipe';
import { QuickSearchComponent } from '../../../form/quick-search/quick-search.component';

@Component({
    selector: 'arc-quick-search-column',
    templateUrl: './quick-search-column.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [QuickSearchComponent, ReactiveFormsModule, FormControlPipe, QuickSearchConfigPipe]
})
export class QuickSearchColumnComponent<T extends Identifyable<TId>, TId = number> extends BaseColumnComponent<T, TId> implements OnInit {
    readonlyControl = new FormControl();

    get castedCellModel(): QuickSearchColumnModel {
        return this.columnModel as QuickSearchColumnModel;
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.readonlyControl.disable();
        this.readonlyControl.setValue(this.getItemValue(this.columnModel.propertyName));
    }
}
